import { z } from "zod";
import { subscriptionStatusSchema, } from "./vocabulary.js";
// Re-export the operational subscription lifecycle status so webhook, connector
// and worker code depend on the single domain source of truth (the SQL
// app_private.subscription_status enum is held in lockstep by
// supabase/tests/database/static-self-check.mjs).
export { subscriptionStatusSchema };
/**
 * Redaction boundary for Graph webhook and subscription-renewal telemetry. A
 * log/audit safe-code may only carry a bounded, lowercase-safe token — never a
 * raw Graph error, a clientState, a subscription GUID or any content. Mirrors
 * the worker/domain notification safe-code guard and the SQL last_error_code
 * check on app_private.graph_change_subscriptions.
 */
export const graphWebhookSafeCodeSchema = z
    .string()
    .regex(/^[a-z0-9][a-z0-9_]{0,127}$/u);
/**
 * The source kinds Obsina subscribes to for change notifications: a subset of
 * the full source_kind vocabulary limited to streams that carry a Graph
 * change-notification resource. Attachments, documents and WhatsApp messages
 * have no Graph subscription surface.
 */
export const graphSubscriptionSourceKinds = [
    "email_message",
    "calendar_event",
    "teams_message",
];
export const graphSubscriptionSourceKindSchema = z.enum(graphSubscriptionSourceKinds);
/**
 * Graph batches a single POST into a changeNotificationCollection, so a request
 * may carry several notifications. The endpoint reads ONLY the two trigger
 * fields below — `subscriptionId` to map to a connection and `clientState` to
 * verify the shared secret. Every other field a real payload carries (resource,
 * resourceData, changeType, tenantId, subscriptionExpirationDateTime, …) is
 * dropped by Zod's default strip so no content or provider identity can ride
 * along. `clientState` is optional because lifecycle notifications may omit it;
 * a missing or mismatched value simply drops the notification (fail closed).
 */
export const graphChangeNotificationSchema = z.object({
    subscriptionId: z.string().min(1).max(256),
    clientState: z.string().min(1).max(128).optional(),
});
export const GRAPH_CHANGE_NOTIFICATION_BATCH_MAX = 100;
export const graphChangeNotificationCollectionSchema = z.object({
    value: z
        .array(graphChangeNotificationSchema)
        .max(GRAPH_CHANGE_NOTIFICATION_BATCH_MAX),
});
//# sourceMappingURL=graph-subscription.js.map